<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ headerColor }}-6">
						<h4 class="card-title">
							<i class="material-icons pointer" (click)="back()" title="Back">arrow_left</i>
							Batch print invoices &amp; credits
						</h4>
						<p class="card-category">By customer: pick lines, select invoices/credits, download merged PDF. By upload: drop an XLSX, pick the order # column, print.</p>
					</div>
					<div class="card-body">
						<div class="m-auto batch-invoice-print__main-width">
							<div class="mb-3">
								<mat-button-toggle-group [value]="mode" (change)="onModeChange($event.value)" name="bipMode">
									<mat-button-toggle value="customer">By customer</mat-button-toggle>
									<mat-button-toggle value="upload">Upload XLSX</mat-button-toggle>
								</mat-button-toggle-group>
							</div>

							<div *ngIf="mode === 'upload'" class="batch-invoice-print__upload">
								<div class="row">
									<div class="col-lg-7 mb-3">
										<mat-card class="bip-upload-panel h-100">
											<mat-card-subtitle class="bip-upload-card-heading">1. Drop your spreadsheet</mat-card-subtitle>
											<mat-card-content>
												<p class="text-muted small mb-3">
													Drop a <strong>CSV</strong> or <strong>Excel</strong> file containing the order numbers you want to print invoices for.
													The first sheet is read in your browser — nothing is uploaded until you click <strong>Print invoices</strong>.
												</p>
												<ngx-dropzone
													class="bip-upload-dropzone"
													[multiple]="false"
													[expandable]="true"
													accept=".csv,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/plain"
													(change)="onUploadDropzoneSelect($event)"
													*ngIf="!uploadParsing && !uploadColumns.length">
													<ngx-dropzone-label>
														<div class="order-upload-dropzone__inner">
															<mat-icon class="order-upload-dropzone__icon" aria-hidden="true">cloud_upload</mat-icon>
															<span class="order-upload-dropzone__title">Drop one file here</span>
															<span class="order-upload-dropzone__hint">CSV or Excel (.xlsx, .xls) — first sheet only.</span>
														</div>
													</ngx-dropzone-label>
												</ngx-dropzone>

												<div *ngIf="uploadParsing" class="order-upload-processing text-center py-4">
													<mat-spinner diameter="40" class="order-upload-processing__spinner"></mat-spinner>
													<p class="order-upload-processing__title mt-3 mb-1">Reading file…</p>
													<p class="order-upload-processing__hint text-muted small mb-0">Parsing the spreadsheet and finding your columns.</p>
												</div>

												<div *ngIf="uploadColumns.length && uploadFiles.length" class="bip-upload-loaded-file d-flex align-items-center flex-wrap">
													<mat-icon class="text-success mr-1" style="font-size: 20px; width: 20px; height: 20px;">insert_drive_file</mat-icon>
													<span class="small text-dark mr-2 text-truncate" style="max-width: 280px;">{{ uploadFiles[0]?.name }}</span>
													<span class="small text-muted mr-2">{{ formatFileSizeKb(uploadFiles[0]?.size || 0) }} KB · {{ uploadRows.length }} row(s)</span>
													<button mat-stroked-button type="button" color="warn" class="py-0" (click)="clearUpload()">
														<mat-icon>close</mat-icon>
														Remove
													</button>
												</div>
											</mat-card-content>
										</mat-card>
									</div>

									<div class="col-lg-5 mb-3">
										<mat-card class="bip-upload-panel h-100">
											<mat-card-subtitle class="bip-upload-card-heading">2. Pick the order # column</mat-card-subtitle>
											<mat-card-content>
												<p class="text-muted small mb-3" *ngIf="!uploadColumns.length">
													Once the file is loaded, the column dropdown lights up. We try to auto-pick the one that looks like the order number.
												</p>
												<ng-container *ngIf="uploadColumns.length">
													<mat-form-field appearance="outline" class="w-100">
														<mat-label>Order # column</mat-label>
														<mat-select [(ngModel)]="uploadOrderColumn" (selectionChange)="onUploadColumnChange()">
															<mat-option *ngFor="let c of uploadColumns" [value]="c">{{ c }}</mat-option>
														</mat-select>
														<mat-hint>{{ uploadOrders.length }} distinct order #s found</mat-hint>
													</mat-form-field>

													<div class="bip-upload-preview mt-3" *ngIf="uploadOrders.length">
														<div class="small text-muted mb-1">Preview</div>
														<div class="bip-upload-preview-chips">
															<span class="bip-upload-chip" *ngFor="let o of uploadOrders.slice(0, 12)">{{ o }}</span>
															<span class="small text-muted" *ngIf="uploadOrders.length > 12">+ {{ uploadOrders.length - 12 }} more</span>
														</div>
													</div>
												</ng-container>
											</mat-card-content>
											<mat-card-actions align="end" class="pb-3 pt-0" *ngIf="uploadColumns.length">
												<button mat-stroked-button type="button" color="warn" (click)="clearUpload()">
													<mat-icon>refresh</mat-icon>
													Start over
												</button>
											</mat-card-actions>
										</mat-card>
									</div>
								</div>

								<div *ngIf="printing && batchDocProgress.total" class="batch-invoice-print__progress mb-3">
									<div class="d-flex justify-content-between align-items-center small mb-1">
										<span>{{ batchDocProgress.label }}</span>
										<span>{{ batchDocProgress.current }} / {{ batchDocProgress.total }}</span>
									</div>
									<mat-progress-bar mode="determinate" [value]="batchDocProgressPercent"></mat-progress-bar>
									<button mat-stroked-button type="button" color="warn" class="mt-2" (click)="cancelBatchPrint()">Cancel</button>
								</div>
								<mat-progress-bar
									*ngIf="printing && !batchDocProgress.total"
									[mode]="downloadProgress ? 'determinate' : 'indeterminate'"
									[value]="downloadProgress"
									class="mb-3"
								></mat-progress-bar>

								<div class="d-flex justify-content-end">
									<button mat-raised-button color="accent" (click)="bulkPrintFromUpload()" [disabled]="printing || uploadOrders.length === 0">
										<mat-icon>picture_as_pdf</mat-icon>
										Print invoices ({{ uploadOrders.length }})
									</button>
								</div>
							</div>

							<div *ngIf="mode === 'customer'" class="batch-invoice-print__flow">
								<h5 class="batch-invoice-print__section-title">1. Customer</h5>
								<app-customer-lookup [lookupOnly]="true" (customer_selected)="onCustomerSelected($event)"></app-customer-lookup>
								<div class="batch-invoice-print__selected mt-3 pt-3" *ngIf="customer">
									<div class="d-flex flex-wrap align-items-center">
										<span class="text-primary font-weight-bold mr-2">{{ customer.debtorno }}.{{ customer.branchcode }}</span>
										<span *ngIf="customer.name" class="mr-2">{{ customer.name }}</span>
										<button mat-stroked-button type="button" color="warn" (click)="clearCustomer()">Clear customer</button>
									</div>
								</div>

								<ng-container *ngIf="customer">
									<div class="batch-invoice-print__step">
										<h5 class="batch-invoice-print__section-title">2. Date range &amp; load</h5>
										<div class="row m-0 align-items-end">
											<div class="col-12 col-md-3">
												<mat-form-field appearance="outline" class="w-100">
													<mat-label>From</mat-label>
													<input matInput type="date" [formControl]="fromdateCtrl" />
												</mat-form-field>
											</div>
											<div class="col-12 col-md-3">
												<mat-form-field appearance="outline" class="w-100">
													<mat-label>To</mat-label>
													<input matInput type="date" [formControl]="todateCtrl" />
												</mat-form-field>
											</div>
											<div class="col-12 col-md-2">
												<mat-form-field appearance="outline" class="w-100">
													<mat-label>Limit</mat-label>
													<input matInput type="number" [formControl]="translimit" min="1" max="5000" />
												</mat-form-field>
											</div>
											<div class="col-12 col-md-2 d-flex align-items-center pb-2">
												<mat-checkbox [formControl]="opentrans">Open only</mat-checkbox>
											</div>
											<div class="col-12 col-md-2">
												<button mat-raised-button color="primary" class="w-100" (click)="loadTransactions()" [disabled]="loading">
													<mat-spinner diameter="20" *ngIf="loading" class="me-2 d-inline-block align-middle"></mat-spinner>
													Load
												</button>
											</div>
										</div>
									</div>
								</ng-container>

								<ng-container *ngIf="customer && dataSource.data.length">
									<div class="batch-invoice-print__step">
										<h5 class="batch-invoice-print__section-title">3. Select &amp; print</h5>
										<div class="row m-0 mb-3 align-items-end">
											<div class="col-12 col-lg-4 mb-2 mb-lg-0">
												<mat-button-toggle-group [(ngModel)]="typeScope" (ngModelChange)="onTypeScopeChange()" name="typeScope" class="batch-invoice-print__toggles">
													<mat-button-toggle value="both">Invoices &amp; credits</mat-button-toggle>
													<mat-button-toggle value="invoice">Invoices</mat-button-toggle>
													<mat-button-toggle value="credit">Credits</mat-button-toggle>
												</mat-button-toggle-group>
											</div>
											<div class="col-12 col-lg-5 mb-2 mb-lg-0">
												<mat-form-field appearance="outline" class="w-100">
													<mat-label>Filter table</mat-label>
													<input matInput [formControl]="tableFilter" placeholder="Trans #, order #, text…" />
												</mat-form-field>
											</div>
											<div class="col-12 col-lg-3 d-flex flex-wrap">
												<button mat-stroked-button type="button" class="mr-2 mb-2" (click)="masterToggle(true)" [disabled]="!selectableRows().length">Select all</button>
												<button mat-stroked-button type="button" class="mb-2" (click)="masterToggle(false)">Select none</button>
											</div>
										</div>

										<div *ngIf="printing && batchDocProgress.total" class="batch-invoice-print__progress mb-3">
											<div class="d-flex justify-content-between align-items-center small mb-1">
												<span>{{ batchDocProgress.label }}</span>
												<span>{{ batchDocProgress.current }} / {{ batchDocProgress.total }}</span>
											</div>
											<mat-progress-bar mode="determinate" [value]="batchDocProgressPercent"></mat-progress-bar>
											<button mat-stroked-button type="button" color="warn" class="mt-2" (click)="cancelBatchPrint()">Cancel</button>
										</div>
										<mat-progress-bar
											*ngIf="printing && !batchDocProgress.total"
											[mode]="downloadProgress ? 'determinate' : 'indeterminate'"
											[value]="downloadProgress"
											class="mb-3"
										></mat-progress-bar>

										<div class="table-responsive batch-invoice-print__table-wrap">
											<table mat-table [dataSource]="dataSource" class="w-100">
												<ng-container matColumnDef="select">
													<th mat-header-cell *matHeaderCellDef>
														<mat-checkbox
															(change)="masterToggle($event.checked)"
															[checked]="isAllSelected()"
															[indeterminate]="isSomeSelected()"
															[disabled]="!selectableRows().length"
														>
														</mat-checkbox>
													</th>
													<td mat-cell *matCellDef="let row">
														<mat-checkbox
															(click)="$event.stopPropagation()"
															(change)="onRowCheckboxChange($event.checked, row)"
															[disabled]="!isPrintableRow(row)"
															[checked]="selection.isSelected(row)"
														>
														</mat-checkbox>
													</td>
												</ng-container>
												<ng-container matColumnDef="trandate">
													<th mat-header-cell *matHeaderCellDef>Date</th>
													<td mat-cell *matCellDef="let row">{{ row.trandate }}</td>
												</ng-container>
												<ng-container matColumnDef="typename">
													<th mat-header-cell *matHeaderCellDef>Type</th>
													<td mat-cell *matCellDef="let row">{{ row.typename }}</td>
												</ng-container>
												<ng-container matColumnDef="transno">
													<th mat-header-cell *matHeaderCellDef>Trans #</th>
													<td mat-cell *matCellDef="let row">{{ row.transno }}</td>
												</ng-container>
												<ng-container matColumnDef="order_">
													<th mat-header-cell *matHeaderCellDef>Order</th>
													<td mat-cell *matCellDef="let row">{{ row.order_ }}</td>
												</ng-container>
												<ng-container matColumnDef="totalamount">
													<th mat-header-cell *matHeaderCellDef class="text-end">Amount</th>
													<td mat-cell *matCellDef="let row" class="text-end">{{ row.totalamount }}</td>
												</ng-container>
												<ng-container matColumnDef="balance">
													<th mat-header-cell *matHeaderCellDef class="text-end">Balance</th>
													<td mat-cell *matCellDef="let row" class="text-end">{{ row.balance }}</td>
												</ng-container>
												<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
												<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
											</table>
										</div>

										<div class="row m-0 mt-3 pt-3 batch-invoice-print__footer align-items-center">
											<div class="col-12 col-md text-muted mb-2 mb-md-0">
												Selected: {{ selection.selected.length }} (invoices &amp; credits only)
											</div>
											<div class="col-12 col-md-auto text-md-right">
												<button mat-raised-button color="accent" (click)="batchPrint()" [disabled]="printing || selection.selected.length === 0">
													<mat-icon>picture_as_pdf</mat-icon>
													Batch print PDF
												</button>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
